export type RangeLabelType = 'number' | 'date' | 'datetime' | 'time';

export function getEqualLabelKeyForType(type: RangeLabelType): string {
  switch (type) {
    case 'number':
      return 'LanguageService::Number';
    case 'date':
    case 'datetime':
      return 'LanguageService::Date';
    case 'time':
      return 'LanguageService::Time';
    default:
      return '';
  }
}
